import React, {useState, useEffect, useRef} from 'react';
import {findCustomersByQueryString} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";

const apiUrl = Config.apiUrl;
const SaleManagerCustomer = () => {
        const [customers, setCustomers] = useState([]);
        const [filteredCustomers, setFilteredCustomers] = useState([]);
        const [queryString, setQueryString] = useState('');
        const inputQueryString = useRef(null);
        const [, setLoading] = useRecoilState(loadingAtom);
        const navigate = useNavigate();
        const sale = JSON.parse(localStorage.getItem('sale'));

        async function makeQuery(query) {
            try {
                setLoading(true);
                const customers = await findCustomersByQueryString(query);
                setCustomers(customers);
                setFilteredCustomers(customers);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
                setLoading(false);
            }
        }

        useEffect(() => {
            if (inputQueryString.current) {
                inputQueryString.current.focus();
            }
            makeQuery('');
        }, []);

        function removeSpecialChars(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        }

        const handleInputChange = (e) => {
            const string = removeSpecialChars(e.target.value).toUpperCase();
            const filteredCustomers = customers.filter((f) => removeSpecialChars(f.name).toUpperCase().includes(string));
            setFilteredCustomers(filteredCustomers);
            setQueryString(string);
        };

        return (
            <>
                <div className="header-label">Comanda</div>

                <div
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                    className="input-container">
                    <input style={{width: '100%'}} ref={inputQueryString} type="text" value={queryString}
                           onChange={handleInputChange} onFocus={(event) => event.target.select()} inputMode="numeric"/>
                    <button id="clearButton" onClick={() => {
                        setQueryString('');
                        inputQueryString.current.focus();
                    }}>X
                    </button>
                </div>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '300px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>
                            Nome
                        </th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {filteredCustomers.map((customer, index) => (
                        <tr key={index}>
                            <td>
                                <div key={index}>{customer.name}</div>
                            </td>
                            <td>
                                <button onClick={async () => {
                                    const newSale = {table: sale.table, customer: customer};
                                    localStorage.setItem('sale', JSON.stringify(newSale));
                                    navigate("/sale/items");
                                }}>Selecionar
                                </button>
                            </td>

                        </tr>
                    ))}
                    </tbody>
                    {customers.length === 0 &&
                        <tfoot>
                        <tr>
                            <td colSpan={5}>
                                Nenhum item encontrado
                            </td>
                        </tr>
                        </tfoot>
                    }
                </table>
            </>
        );
    }
;

export default SaleManagerCustomer;
